import _ from 'lodash';

import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';
import { stripTrailingSlash } from 'app/common/utils/UrlUtils';
import {
  currentAppId,
  currentAppVersion,
} from 'app/developer-v3/utils/selectors';

export const type = 'environmentVariable';

export const api = buildEntityApi(type, (path, getState) => {
  const state = getState();
  const appId = currentAppId(state);
  const appVersion = currentAppVersion(state);
  return stripTrailingSlash(
    `/api/platform/cli/apps/${appId}/versions/${appVersion}/environment`
  );
});

export const selectors = buildEntitySelectors(type, sel => {
  sel.appId = _.partial(sel.dataItem, 'app_id');
  sel.appVersion = _.partial(sel.dataItem, 'app_version');
  sel.key = _.partial(sel.dataItem, 'key');
  sel.value = _.partial(sel.dataItem, 'value');

  const hasAppIdAndVersion = (appId, version, entity) => {
    return (
      sel.appId(entity) === Number(appId) && sel.appVersion(entity) === version
    );
  };

  sel.all.environmentVariablesForVersion = _.partial(
    sel.all.filterBy,
    hasAppIdAndVersion
  );

  const hasAppIdAndVersionAndKey = (appId, version, key, entity) => {
    return (
      sel.appId(entity) === Number(appId) &&
      sel.appVersion(entity) === version &&
      sel.key(entity) === key
    );
  };

  sel.all.entityForKeyAndVersion = _.partial(
    sel.all.findBy,
    hasAppIdAndVersionAndKey
  );
});

export const actions = buildEntityActions(
  type,
  selectors,
  api,
  environmentVariableActions => {
    environmentVariableActions.updateValue = (entityId, newValue) => {
      return async dispatch => {
        dispatch(actions.updateEntityDataItem('value', newValue, entityId));
        return await dispatch(
          actions.saveEntity(
            { failure: 'There was a problem saving the environment variable' },
            entityId
          )
        );
      };
    };
  }
);

export const constants = {
  OAUTH_CLIENT_ID: 'CLIENT_ID',
  OAUTH_CLIENT_SECRET: 'CLIENT_SECRET',
};
